import { MenuItem } from "@mui/material";
import { styled } from "@mui/material/styles";

export const CustomMenuItem = styled(MenuItem)(({ theme }) => ({
  backgroundColor: "transparent",
  borderRadius: "10px",
  padding: "5px 8px",
  margin: "4px 10px",
  fontFamily: "Outfit",
  "&:hover": {
    backgroundColor: "#F2F0F9 !important",
  },
  "&.Mui-selected": {
    backgroundColor: "#F2F0F9 !important",
  },
}));
